module.exports = [{"type":"hash","text":"數字規範"},{"type":"normal","text":"","children":[{"type":"html","text":"為了保持跨平台時精度的完整性，十進制數字作為字符串返回。建議您在發起請求時也将數字轉換為字符串以避免截斷和精度錯誤"},{"type":"html","text":"整數（如交易編號和順序）不加引號"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/swapV2/api/basic/03_digital_rule.json
// module id = v0HI
// module chunks = 3